module.exports = {
  domain: {
    desktop: "www.int.use2.racing.fndlext.net",
    mobile: "www.int.use2.racing.fndlext.net",
    talentPicks: "www.int.use2.racing.fndlext.net/talent-picks/",
    accountWallet: "account.racing.qa.fndl.dev",
    equibase: "equibase-store-qa.tvg.com"
  },
  recaptchaID: "6Lf-4hUqAAAAAGupa6W70kpZVsaFd7yaxz5pHD8r",
  recaptchaIdNative: "6Le9B1YqAAAAAJEWJZsQittPtHDcjz6xLNORgHyI"
};
